const modal_video = document.getElementById("modal-video");

if (modal_video) {
  const btn_close = modal_video.querySelector(".btn-close");
  const video = modal_video.querySelector("video");
  const video_wrapper = modal_video.querySelector(".video-contain");

  //% Trigger unmount event when close button is clicked
  btn_close.onclick = () => {
    triggerEvent(window, "video_unmount");
  };

  //% Handle Video Mount Event
  window.addEventListener("video_mount", () => {
    modal_video.classList.add("open");
    video.play();
    // console.trace("Custom open event triggered!");

    //% Disable window scroll
    triggerEvent(window, "scroll_stop");
  });

  //% Handle Video Unmount Event
  window.addEventListener("video_unmount", () => {
    modal_video.classList.remove("open");
    video.pause();
    // console.trace("Custom close event triggered!");

    //% Enable window scroll
    triggerEvent(window, "scroll_start");
  });
}
